module.exports = __webpack_public_path__ + "static/media/typeOrientations.39c09309.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/typeOrientations.svg
// module id = 873
// module chunks = 0